namespace $.$$ {

	$mol_style_define( $shm_wordstat_chart_timeseries, {
		position: 'relative',
		flex: {
			direction: 'column',
			grow: 0,
			shrink: 0,
		},
		minHeight: '40rem',
		Chart: {
			flex: {
				grow: 1,
			},
			minHeight: '40rem',
		},
	} )

}
